import { useEffect } from 'react';
import axios from 'axios';
import * as CookieConsent from 'vanilla-cookieconsent';
import { setGoogleAnalyticsRuntimeConfig, syncGoogleAnalyticsWithConsent } from '../lib/googleAnalytics';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Charge la config Google Analytics depuis l'API (MongoDB) puis synchronise avec le consentement cookies.
 */
const GoogleAnalyticsConfigLoader = () => {
  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/google-analytics-config`);
        if (cancelled) return;
        setGoogleAnalyticsRuntimeConfig(data || { enabled: false });
      } catch {
        if (cancelled) return;
        setGoogleAnalyticsRuntimeConfig({ enabled: false });
      }
      if (!cancelled) {
        syncGoogleAnalyticsWithConsent(CookieConsent.acceptedCategory('analytics'));
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default GoogleAnalyticsConfigLoader;
